export default __webpack_public_path__ + "static/disability-confident-b62ef0e70ccea3cdb68e46957a8f9249.png";